<template>
    <TheFooter>
        <div class="footer-wrapper d-flex align-items-center justify-content-between">
			<div class="footer-copyright">
			<!--footer-->
				<a href="https://www.indocyber.co.id/"></a>
				<span>&copy; 2020 {{ $footerName }}. {{version}}</span>
			</div>
        </div>
    </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
  data() {
	  return { 
		  hash:process.env.VUE_APP_GIT_HASH ,
		  version:localStorage.getItem("version")
		} 
	}
}
</script>
